import { Menu } from 'antd'
import { useNavigate } from 'react-router-dom'
import { AlignCenterOutlined } from "@ant-design/icons"
import BottomBar from './BottomBar'
import { Fragment } from 'react';
function MenuList({ active, setactive, k }) {
    const navigate = useNavigate();
    const items = [
        {
            label: "Usama Tanveer",
            key: 0,
            className: 'Logo',
            onClick: () => navigate('/')
        },
        {
            label: "Home",
            key: 1,
            className: "hideOnMedia",
            onClick: () => navigate('/')
        },
        {
            label: "About",
            key: 2,
            className: "hideOnMedia",
            onClick: () => navigate('/about')
        },
        {
            label: "Portfolio",
            key: 3,
            className: "hideOnMedia",
            onClick: () => navigate('/portfolio')
        },
        {
            label: "Get a Word",
            key: 4,
            className: "hideOnMedia",
            onClick: () => navigate('/contact')
        },
        {
            label: (
                <AlignCenterOutlined
                    style={{ fontSize: "1.3rem" }}
                    onClick={() => setactive(e => !e)}
                />
            ),
            key: 5,
            className: `showOnMedia ${active && "active"}`
        }
    ]
    return (
        <Fragment>
            <Menu
                theme="dark"
                mode="horizontal"
                selectedKeys={k}
                className="NavBar"
                disabledOverflow={true}
                items={items}
            />
            <BottomBar active={active} />
        </Fragment>
    )
}

export default MenuList